import { useScrollReveal } from "@/hooks/useScrollReveal";
import { blogPosts } from "@/data/blog";
import { Calendar, Tag } from "lucide-react";

function formatDate(date: string): string {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function Blog() {
  const headerRef = useScrollReveal<HTMLDivElement>({ y: 30 });
  const published = blogPosts.filter((p) => p.published);

  return (
    <section id="blog" className="min-h-screen px-6 py-24">
      <div className="max-w-3xl mx-auto">
        <div ref={headerRef} className="mb-12">
          <div data-reveal className="flex items-center gap-3 mb-2">
            <span className="text-terminal-green">$</span>
            <span className="text-terminal-cyan">cat</span>
            <span className="text-foreground">./blog/*.md</span>
          </div>
          <h2
            data-reveal
            className="text-2xl font-bold text-terminal-bright"
          >
            Blog
          </h2>
          <p data-reveal className="text-muted-foreground mt-1">
            {published.length} posts published
          </p>
        </div>

        <div className="space-y-4">
          {published.map((post, index) => (
            <BlogPostCard key={post.id} post={post} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

function BlogPostCard({
  post,
  index,
}: {
  post: (typeof blogPosts)[number];
  index: number;
}) {
  const ref = useScrollReveal<HTMLDivElement>({ y: 30, delay: index * 0.1 });

  return (
    <article
      ref={ref}
      data-reveal
      className="border border-border rounded-lg p-5 bg-card hover:border-terminal-green/30 transition-all group cursor-pointer"
    >
      <div className="flex items-center gap-4 mb-3 text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5">
          <Calendar size={12} />
          {formatDate(post.date)}
        </span>
        <span className="flex items-center gap-1.5">
          <Tag size={12} />
          {post.tags.slice(0, 3).join(", ")}
        </span>
      </div>

      <h3 className="text-lg font-bold text-terminal-bright mb-2 group-hover:text-terminal-green transition-colors">
        {post.title}
      </h3>

      <p className="text-sm text-muted-foreground leading-relaxed">
        {post.excerpt}
      </p>

      <div className="mt-4 text-sm text-terminal-dim group-hover:text-terminal-green transition-colors">
        <span className="text-terminal-green">$</span>
        <span className="ml-2">read more →</span>
      </div>
    </article>
  );
}
